import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
	selector: 'app-city-input',
	templateUrl: './city-input.component.html',
	styleUrls: ['./city-input.component.scss']
})
export class CityInputComponent {

	@Input('formFieldClass') m_formFieldClass: string = 'w-100';
	@Input('required') m_required: boolean = true;
	@Input('cityCtrl') m_cityCtrl: FormControl<string>;

	@Input('cities') m_cities: string[] = [];

	constructor() { }

}